import { useSpring, animated, useSprings } from '@react-spring/web';
// import { cubicBezier } from 'react-native-redash'; // or any cubicBezier implementation you like
import { bezier } from '../utilities/bezier-utils'
import { CubicBounceLerp } from '../types/bounce-types';
import { displayBounceDurationDefault } from '../assets/constants';

type useSpringObj = {
    width: number,
    config: {
        duration: number,
        easing: (x: number) => number
    }
}

const buildSprings = (values: any[], width: number): useSpringObj[] => {
    let halfBounces = []
    for (let i = 0; i < values.length; i++) {
        let duration = (values[i].dstLerpX - values[i].ognLerpX) / 2 * displayBounceDurationDefault
        let xRange = width / 2
        let inEase = bezier(1 - values[i].ognXCubic, 1 - values[i].ognYCubic, values[i].dstXCubic, values[i].dstYCubic)
        let xVal = (values[i].dstLerpY * xRange / 2) + width/5
        if (xVal > width) xVal = width
        if (xVal < 0) xVal = 0
        if (i % 2 === 0) {
            let inBounce: useSpringObj = {
                width: xVal,
                config: { duration: duration, easing: inEase }
            }
            halfBounces.push(inBounce)
        } else {
            let outBounce: useSpringObj = {
                width: xVal,
                config: { duration: duration, easing: inEase, }
     
            }
            halfBounces.push(outBounce)
        }

    }
    return halfBounces
}

//@ts-ignore
export const ElasticPreview = ({ bounceValues, width, height }) => {
    
    const builtSprings = buildSprings(bounceValues, width)
    //@ts-ignore
    const springs = useSpring({
        from: { background: '#007bff', y: 0, x: 0 },
        to: builtSprings,
      }) 
  
    return (
        <div>    
         <animated.div
        //@ts-ignore
          style={{
          height: '4px',
          borderRadius: 0,
          marginTop: '6px',
        //   marginTop: '1vh',
          ...springs,
            }}
        />
 
      </div>
    );
  }